const format = (data: string) => {
	if (!data) {
		return
	}

	let res = []

	for (let i = 0; i < data?.length; i++) {
		const char = data[i]
		const charCode = data.charCodeAt(i)

		if (
			charCode === 8203 ||
			(charCode >= 8204 && charCode <= 8207) ||
			charCode === 65279 ||
			charCode == 6069
		) {
			res.push('💣')
		}

		res.push(char)
	}

	return res.join('')
}

export default format
